import React from 'react';
import ColorVariantsQuery from './ColorVariantsQuery.gql';
import { useLocation } from 'react-router';
import { Query } from 'react-apollo';
import styled from 'react-emotion';
import Image from '@jetshop/ui/Image';
import ProductLink from '@jetshop/ui/ProductLink';
import { theme } from '../../Theme';
import t from '@jetshop/intl';

const Container = styled('div')`
  padding: 0 0 0px 0;
`;

const Label = styled('label')`
  display: block;
  padding: 0 0 5px;
`;

const ProductList = styled('ul')`
  display: flex;
`;

const VariantProd = styled('li')`
  width: 50px;
  margin: 0 7px 10px 3px;
  position: relative;

  a {
    display: block;
  }

  &.current {
    &::before {
      content: '';
      position: absolute;
      top: -3px;
      right: -3px;
      bottom: -3px;
      left: -3px;
      border: 1px solid ${theme.colors.black};
    }

    a {
      cursor: default;
    }
  }

  &:hover {
    span {
      max-height: 50px;
      opacity: 1;
      transition: opacity 0.2s, max-height 0s 0s;
      overflow: visible;
    }
  }
`;

const StyledImage = styled(Image)``;

const ProductName = styled('span')`
  position: absolute;
  top: -47px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  max-height: 0;
  transition: opacity 0.2s, max-height 0s 0.3s;
  display: none;
  font-size: 1rem;
  background:  ${theme.colors.black};
  color:  ${theme.colors.pink};
  z-index: 3;
  white-space: nowrap;
  line-height: 1.3;
  padding: 8px 13px;
  //border: 1px solid  ${theme.colors.black};
  box-shadow: 1px 1px 4px rgba(0,0,0,0.2);
  
  &::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-top-color: ${theme.colors.black};
    position:absolute;
    bottom: -10px;
    left: calc(50% - 3px);
  }
  
`;

const ColorVariants = props => {
  const location = useLocation();
  const { pathname, search } = location;
  const modelNumber = props.product.articleNumber.substr(0, 5);

  return (
    <Query query={ColorVariantsQuery} variables={{ term: modelNumber }}>
      {({ loading, error, data }) => {
        if (loading) return <span>.</span>;
        if (error)
          return (
            <div>
              Ett fel har uppstått vid inhämtningen av produktdatan. Försök igen
              senare.
            </div>
          );

        // SUCCESS
        const colorVariantProds = data.search.products.result;
        return colorVariantProds.length > 1 ? (
          <Container>
            <Label>{t('Färg')}</Label>
            <ProductList>
              {colorVariantProds.map((variantProd, index) => {
                const isCurrent =
                  variantProd.articleNumber === props.product.articleNumber;
                const prodImages = variantProd.images;
                const isValidModel =
                  modelNumber === variantProd.articleNumber.substr(0, 5);
                if (prodImages.length && isValidModel) {
                  const imgToShow =
                    prodImages.length > 1 ? prodImages[1] : prodImages[0];
                  return (
                    <VariantProd
                      key={variantProd.name}
                      className={isCurrent ? 'current' : ''}
                    >
                      <ProductLink product={variantProd}>
                        <StyledImage
                          src={imgToShow.url}
                          aspect="1:1"
                          sizes={100}
                          cover={true}
                          alt={imgToShow.alt}
                        />
                        <ProductName>{variantProd.name}</ProductName>
                      </ProductLink>
                    </VariantProd>
                  );
                }
              })}
            </ProductList>
          </Container>
        ) : null;
      }}
    </Query>
  );
};

export default ColorVariants;
